/* eslint-disable no-unused-vars*/
import React, { Component } from 'react'
/* eslint-enable no-unused-vars*/
import PropTypes from 'prop-types'

class DropDownFilterBase extends Component {

  state = {
    open: false,
  }

  toggleClick = (evt) => {
    evt.preventDefault()
    evt.stopPropagation()
    if (this.state.open)
      this.closeMenu(evt)
    else
      this.openMenu()
  }

  openMenu = () => {
    document.addEventListener('click', this.closeMenu, false)
    this.setState({
      open: true,
    })
  }

  closeMenu = () => {
    document.removeEventListener('click', this.closeMenu, false)
    this.setState({
      open: false,
    })
  }

  listClick = (evt) => {
    evt.stopPropagation()
    evt.nativeEvent.stopImmediatePropagation()
  }
}

DropDownFilterBase.propTypes = {
  children: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
}

export default DropDownFilterBase
